import React, { useEffect } from "react"
import DataTable from "../../../../components/atoms/table/DataTable.atom"
import Column from "../../../../components/atoms/table/Column.atom"
import ColumnContent from "./ColumnContent.controller"
import { DateTime } from "luxon"
import useScreenDimensionsContext from "../../../../hooks/contextConsumers/useScreenDimensionsContext.hook"
import { clsx } from "../../../../utils/strings.utils"

const MONTHS_SPANISH = [
  "ENE",
  "FEB",
  "MAR",
  "ABR",
  "MAY",
  "JUN",
  "JUL",
  "AGO",
  "SEP",
  "OCT",
  "NOV",
  "DIC",
]

const VacationBucketDaysTable = ({
  bucketDaysInfo,
  monthToHighlight,
  centerHighlightedMonth,
  anniversaryDate,
}) => {
  useEffect(() => {
    document
      ?.querySelector(".bucket-days-info-table__highlighted-month")
      ?.scrollIntoView({ behavior: "smooth", inline: "center" })
  }, [monthToHighlight, centerHighlightedMonth])
  if (monthToHighlight > bucketDaysInfo?.actualAvailableDays?.length) {
    return null
  }

  // * Mobile
  const mobileTableData = []

  for (let i = 0; i < bucketDaysInfo.data[0].monthsData.length; i++) {
    const res = {}
    res.month = MONTHS_SPANISH[bucketDaysInfo.data[0].monthsData[i].month - 1]
    res.initial = bucketDaysInfo.data[0].monthsData[i].daysCounter
    res.highlight = i === monthToHighlight
    res.pastAnniversary = i < monthToHighlight

    res.year = bucketDaysInfo.data[0].monthsData[i].year
    const date = DateTime.now().set({
      year: res.year,
      month: bucketDaysInfo.data[0].monthsData[i].month,
      day: 1,
    })
    res.date = date

    res.taken = bucketDaysInfo.data[1].monthsData[i].daysCounter
    res.final = bucketDaysInfo.data[2].monthsData[i].daysCounter
    mobileTableData.push(res)
  }

  const { screenWidth } = useScreenDimensionsContext()

  const isMobile = screenWidth <= 480

  if (isMobile) {
    const bodyClasses = (e) =>
      clsx(
        "bucket-days-info-table__row-month",
        e.highlight ? "bucket-days-info-table__highlighted-month" : "",
        e.pastAnniversary && "bucket-days-info-table__months-past-anniversary"
      )

    const spanClasses = (fieldName) => (e) => (
      <span className={clsx(e[fieldName] < 0 && "negative-days")}>
        {e[fieldName]}
      </span>
    )

    return (
      <DataTable
        value={mobileTableData}
        className="bucket-days-info-table"
        scrollable
      >
        <Column
          className="bucket-days-info-table__row-name"
          headerClassName="bucket-days-info-table__row-name--header"
          field="month"
          header="Mes"
          body={(e) => {
            return <span>{e.month}</span>
          }}
          bodyClassName={bodyClasses}
          frozen
        />
        <Column
          className="bucket-days-info-table__row-name"
          headerClassName="bucket-days-info-table__row-name--header"
          field="initial"
          header="Inicial"
          body={spanClasses("initial")}
          bodyClassName={bodyClasses}
        />
        <Column
          className="bucket-days-info-table__row-name"
          headerClassName="bucket-days-info-table__row-name--header"
          field="taken"
          header="Tomados"
          body={spanClasses("taken")}
          bodyClassName={bodyClasses}
        />
        <Column
          className="bucket-days-info-table__row-name"
          headerClassName="bucket-days-info-table__row-name--header"
          field="final"
          header="Final"
          body={spanClasses("final")}
          bodyClassName={bodyClasses}
        />
      </DataTable>
    )
  } else {
    return (
      <DataTable
        value={bucketDaysInfo.data}
        className="bucket-days-info-table"
        scrollable
      >
        <Column
          className="bucket-days-info-table__row-name"
          headerClassName="bucket-days-info-table__row-name--header"
          field="name"
          frozen
        />
        {ColumnContent(
          bucketDaysInfo.data[0].monthsData || [],
          monthToHighlight,
          anniversaryDate
        )?.map((column, index) => (
          <Column key={index} {...column} />
        ))}
      </DataTable>
    )
  }
}

export default VacationBucketDaysTable
